export default "__VITE_ASSET__XVExgqk6__"